import { it } from "vuetify/lib/locale";

export default {
  $vuetify: { ...it },
  ...it,
  legal_top: {
    title: "Termini e condizioni",
    text: "Scopri notizie, consigli e approfondimenti per i futuri residenti del nostro esclusivo progetto di vita sostenibile",
  },
  platform: {
    btn_top:{
      btn_cameras: "Web Cameras",
      btn_btob: "Gestione B&B",
      btn_legal: "Aggiornamenti legali",
    },
    title: "Piattaforma per membri",
    welcome: "Benvenuto",
  },
  platform_auth: {
    title: "Piattaforma membri Borgoolistico",
    suptitle: "Accedi con il tuo ID personale e password per accedere alle telecamere e alle informazioni di Borgoolistico",
    btn_login: "Accedi"
  },
  contact: {
    links: {
      call: "Chiamaci",
      insta: "Trovaci su Instagram",
      whatsapp: "Trovaci su WhatsApp",
    }
  },
};
